import { render, staticRenderFns } from "./regist.vue?vue&type=template&id=43ad61fc&scoped=true"
import script from "./regist.vue?vue&type=script&lang=js"
export * from "./regist.vue?vue&type=script&lang=js"
import style0 from "./regist.vue?vue&type=style&index=0&id=43ad61fc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43ad61fc",
  null
  
)

export default component.exports